import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=11f66ff8&"
import script from "./UserInfo.vue?vue&type=script&lang=js&"
export * from "./UserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f66ff8')) {
      api.createRecord('11f66ff8', component.options)
    } else {
      api.reload('11f66ff8', component.options)
    }
    module.hot.accept("./UserInfo.vue?vue&type=template&id=11f66ff8&", function () {
      api.rerender('11f66ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/UserInfo.vue"
export default component.exports